export const duration = 2000;
export const CONTAINER_WIDTH = '46rem';
export const CONTAINER_HEIGHT = '90vh';
export const CONTAINER_EMPTY_HEIGHT = '48vh';
export const WISHLIST_PAGE_SIZE = 3;

export const FIELD_PATTERN = {
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  TEXT: /^[a-zA-Z\s]*$/,
  TEXT_AND_SPACE: /^[a-z A-Z\s]*$/,
  NUMBER: /^[0-9]*$/,
};

const CARD_VALIDATION_DEFAULT_NUMBER = /(\d{1,4})/g;

const CVC_PATTERN_3_NUMBER = /^(\d{3})$/;
const CVC_PATTERN_3_4_NUMBER = /^(\d{3,4})$/;

export const DEAFULT_BOX_CL = 12;
export const URL_EDIT_CL =
  '/ProductDisplay?storeId=##storeId##&orderItemId=##orderItemId##&productId=##productId##&urlRequestType=Base&langId=##langId##&catalogId=##catalogId##';
export const URL_EDIT_WISHLIST_CL =
  '/ProductDisplay?storeId=##storeId##&productId=##productId##&urlRequestType=Base&langId=##langId##&catalogId=##catalogId##';
export const PARAMETER_UPDATE_QUANTITY_CL =
  'storeId=##storeId##&langId=##langId##&catalogId=##catalogId##&orderId=&orderItemId=##orderItemId##&productId=##productId##&contactBrand=##contactBrand##&contactPN=##contactPN##&rightLensItemId=##rightLensItemId##&leftLensItemId=##leftLensItemId##&leftQuantity=##leftQuantity##&type=##type##&newQuantity=##newQuantity##&rightQuantity=##rightQuantity##&FIRST_NAME=&LAST_NAME=&DOCTOR_CLINIC=&DOCTOR_ADDRESS=&DOCTOR_ADDRESS2=&DOCTOR_CITY=&DOCTOR_STATE=&DOCTOR_ZIP=&DOCTOR_NUMBER=&DOCTOR_FAX=&BIRTH_DAY=&BIRTH_MONTH=&BIRTH_YEAR=&URL=';

export const COLLECT_IN_STORE = 'COLLECT_IN_STORE_LABEL';

export const GOOGLE_API_KEY = 'AIzaSyDIKnvcRs67JS68VapIMloObx8Va-J3src';
export const DEFAULT_RADIUS = '50';
export const DATA_GET_STORE = {
  selectedOpeningFilters: [],
  selectedInsuranceFilters: [],
  selectedLanguageFilters: [],
  selectedStatusFilters: ['O'],
  bossEnabled: ['1'],
};

export const badgeLabels = {
  'BADGE_EXCLUSIVE': 'Exclusive',
  'AVANT_PREMIER': 'Find it here first',
  'BADGE_NEW_ARRIVAL': 'New', 
  'BADGE_BEST_SELLER': 'Best Seller', 
  'LIMITED_EDITION': 'Limited Edition',
  'POLARIZED': 'Polarized',
  'GEOFIT': 'Universal Fit',
  'FRAME_LENS_TREATMENT': 'Transition',
  'SUSTAINABILITY_CLAIM': 'Sustainable',
  'ELECTRONICS': 'Smart Glasses',
  'BADGE_KIDS': 'Kids'
}

export const CARD_VALIDATION = {
  generic: {
    type: 'generic',
    format: CARD_VALIDATION_DEFAULT_NUMBER,
    length: [13, 15, 16],
    cvcLength: [3, 4],
    cvcPattern: CVC_PATTERN_3_4_NUMBER,
    luhn: true,
    payMethodId: 'CyberSource',
  },
  Amex: {
    type: 'Amex',
    pattern: /^3[47]/,
    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: [15],
    cvcLength: [3, 4],
    cvcPattern: CVC_PATTERN_3_4_NUMBER,
    luhn: true,
    payMethodId: 'AMEX',
  },
  Visa: {
    type: 'Visa',
    pattern: /^4/,
    format: CARD_VALIDATION_DEFAULT_NUMBER,
    length: [13, 16],
    cvcLength: [3],
    cvcPattern: CVC_PATTERN_3_NUMBER,
    luhn: true,
    payMethodId: 'VISA',
  },
  Mastercard: {
    type: 'Mastercard',
    pattern: /^5[0-5]/,
    format: CARD_VALIDATION_DEFAULT_NUMBER,
    length: [16],
    cvcLength: [3],
    cvcPattern: CVC_PATTERN_3_NUMBER,
    luhn: true,
    payMethodId: 'Master Card',
  },
  Discover: {
    type: 'Discover',
    pattern: /^6([045]|22)/,
    format: CARD_VALIDATION_DEFAULT_NUMBER,
    length: [16],
    minLength: 16,
    maxLength: 16,
    cvcLength: [3],
    cvcPattern: CVC_PATTERN_3_NUMBER,
    luhn: true,
    payMethodId: 'Discover',
  },
};

export const SKELETON = {
  speed: 2,
  backgroundColor: '#d9d9d9',
};

export const states = [
  {
    code: 'AL',
    label: 'AL - Alabama',
    disabled: false,
  },
  {
    code: 'AK',
    label: 'AK - Alaska',
    disabled: false,
  },
  {
    code: 'AZ',
    label: 'AZ - Arizona',
    disabled: false,
  },
  {
    code: 'AR',
    label: 'AR - Arkansas',
    disabled: false,
  },
  {
    code: 'CA',
    label: 'CA - California',
    disabled: false,
  },
  {
    code: 'CO',
    label: 'CO - Colorado',
    disabled: false,
  },
  {
    code: 'CT',
    label: 'CT - Connecticut',
    disabled: false,
  },
  {
    code: 'DE',
    label: 'DE - Delaware',
    disabled: false,
  },
  {
    code: 'DC',
    label: 'DC - District of Columbia',
    disabled: false,
  },
  {
    code: 'FL',
    label: 'FL - Florida',
    disabled: false,
  },
  {
    code: 'GA',
    label: 'GA - Georgia',
    disabled: false,
  },
  {
    code: 'HI',
    label: 'HI - Hawaii',
    disabled: false,
  },
  {
    code: 'ID',
    label: 'ID - Idaho',
    disabled: false,
  },
  {
    code: 'IL',
    label: 'IL - Illinois',
    disabled: false,
  },
  {
    code: 'IN',
    label: 'IN - Indiana',
    disabled: false,
  },
  {
    code: 'IA',
    label: 'IA - Iowa',
    disabled: false,
  },
  {
    code: 'KS',
    label: 'KS - Kansas',
    disabled: false,
  },
  {
    code: 'KY',
    label: 'KY - Kentucky',
    disabled: false,
  },
  {
    code: 'LA',
    label: 'LA - Lousiana',
    disabled: false,
  },
  {
    code: 'ME',
    label: 'ME - Maine',
    disabled: false,
  },
  {
    code: 'MD',
    label: 'MD - Maryland',
    disabled: false,
  },
  {
    code: 'MA',
    label: 'MA - Massachusetts',
    disabled: false,
  },
  {
    code: 'MI',
    label: 'MI - Michigan',
    disabled: false,
  },
  {
    code: 'MN',
    label: 'MN - Minnesota',
    disabled: false,
  },
  {
    code: 'MS',
    label: 'MS - Mississippi',
    disabled: false,
  },
  {
    code: 'MO',
    label: 'MO - Missouri',
    disabled: false,
  },
  {
    code: 'MT',
    label: 'MT - Montana',
    disabled: false,
  },
  {
    code: 'NE',
    label: 'NE - Nebraska',
    disabled: false,
  },
  {
    code: 'NV',
    label: 'NV - Nevada',
    disabled: false,
  },
  {
    code: 'NH',
    label: 'NH - New Hampshire',
    disabled: false,
  },
  {
    code: 'NJ',
    label: 'NJ - New Jersey',
    disabled: false,
  },
  {
    code: 'NM',
    label: 'NM - New Mexico',
    disabled: false,
  },
  {
    code: 'NY',
    label: 'NY - New York',
    disabled: false,
  },
  {
    code: 'NC',
    label: 'NC - North Carolina',
    disabled: false,
  },
  {
    code: 'ND',
    label: 'ND - North Dakota',
    disabled: false,
  },
  {
    code: 'OH',
    label: 'OH - Ohio',
    disabled: false,
  },
  {
    code: 'OK',
    label: 'OK - Oklahoma',
    disabled: false,
  },
  {
    code: 'OR',
    label: 'OR - Oregon',
    disabled: false,
  },
  {
    code: 'PA',
    label: 'PA - Pennsylvania',
    disabled: false,
  },
  {
    code: 'RI',
    label: 'RI - Rhode Island',
    disabled: false,
  },
  {
    code: 'SC',
    label: 'SC - South Carolina',
    disabled: false,
  },
  {
    code: 'SD',
    label: 'SD - South Dakota',
    disabled: false,
  },
  {
    code: 'TN',
    label: 'TN - Tennessee',
    disabled: false,
  },
  {
    code: 'TX',
    label: 'TX - Texas',
    disabled: false,
  },
  {
    code: 'UT',
    label: 'UT - Utah',
    disabled: false,
  },
  {
    code: 'VT',
    label: 'VT - Vermont',
    disabled: false,
  },
  {
    code: 'VA',
    label: 'VA - Virginia',
    disabled: false,
  },
  {
    code: 'WA',
    label: 'WA - Washington',
    disabled: false,
  },
  {
    code: 'WV',
    label: 'WV - West Virginia',
    disabled: false,
  },
  {
    code: 'WI',
    label: 'WI - Wisconsin',
    disabled: false,
  },
  {
    code: 'WY',
    label: 'WY - Wyoming',
    disabled: false,
  },
];

export const smartGlassesDenied = [
  {
    XSTELLAZIPCODENOTALLOWED_ID: 607,
    STORE_ID: '12001',
    LOCATION: 'ALASKA',
    COUNTRY: 'US',
    STATE_PROVINCE: 'AK',
    POSTAL_CODE: '0',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 608,
    STORE_ID: '12001',
    LOCATION: 'HAWAII',
    COUNTRY: 'US',
    STATE_PROVINCE: 'HI',
    POSTAL_CODE: '0',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 609,
    STORE_ID: '12001',
    LOCATION: 'PUERTO RICO',
    COUNTRY: 'US',
    STATE_PROVINCE: 'PR',
    POSTAL_CODE: '0',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 610,
    STORE_ID: '12001',
    LOCATION: 'Catalina Island (Avalon)',
    COUNTRY: 'US',
    STATE_PROVINCE: 'CA',
    POSTAL_CODE: '90704',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 611,
    STORE_ID: '12001',
    LOCATION: 'Beaver Island',
    COUNTRY: 'US',
    STATE_PROVINCE: 'CA',
    POSTAL_CODE: '49782',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 612,
    STORE_ID: '12001',
    LOCATION: 'Mackinac Island',
    COUNTRY: 'US',
    STATE_PROVINCE: 'CA',
    POSTAL_CODE: '49757',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 613,
    STORE_ID: '12001',
    LOCATION: 'The Bass Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'OH',
    POSTAL_CODE: '43446',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 614,
    STORE_ID: '12001',
    LOCATION: 'The Bass Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'OH',
    POSTAL_CODE: '43456',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 615,
    STORE_ID: '12001',
    LOCATION: 'The Bass Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'OH',
    POSTAL_CODE: '43436',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 616,
    STORE_ID: '12001',
    LOCATION: 'Kelleys Island',
    COUNTRY: 'US',
    STATE_PROVINCE: 'OH',
    POSTAL_CODE: '43438',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 617,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98250',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 618,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98250',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 619,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98245',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 620,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98261',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 621,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98279',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 622,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98280',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 623,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98243',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 624,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98286',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 625,
    STORE_ID: '12001',
    LOCATION: 'San Juan Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: 'WA',
    POSTAL_CODE: '98297',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 626,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96910',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 627,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96913',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 628,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96915',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 629,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96919',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 630,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96929',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 631,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96912',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 632,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96916',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 633,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96917',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 634,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96921',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 635,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96923',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 636,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96928',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 637,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96931',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 638,
    STORE_ID: '12001',
    LOCATION: 'Guam',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96932',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 639,
    STORE_ID: '12001',
    LOCATION: 'American Samoa',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96799',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 640,
    STORE_ID: '12001',
    LOCATION: 'Northern Mariana Island',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96950',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 641,
    STORE_ID: '12001',
    LOCATION: 'Northern Mariana Island',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96951',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 642,
    STORE_ID: '12001',
    LOCATION: 'Northern Mariana Island',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96952',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 643,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00801',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 644,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00802',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 645,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00803',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 646,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00804',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 647,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00805',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 648,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00820',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 649,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00821',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 650,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00822',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 651,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00823',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 652,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00824',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 653,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00830',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 654,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00831',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 655,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00840',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 656,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00841',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 657,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00850',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 658,
    STORE_ID: '12001',
    LOCATION: 'United States Virgin Islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '00851',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 659,
    STORE_ID: '12001',
    LOCATION: 'United States Minor Outlying islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96518',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 660,
    STORE_ID: '12001',
    LOCATION: 'United States Minor Outlying islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96516',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 661,
    STORE_ID: '12001',
    LOCATION: 'United States Minor Outlying islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96305',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 662,
    STORE_ID: '12001',
    LOCATION: 'United States Minor Outlying islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96898',
  },
  {
    XSTELLAZIPCODENOTALLOWED_ID: 663,
    STORE_ID: '12001',
    LOCATION: 'United States Minor Outlying islands',
    COUNTRY: 'US',
    STATE_PROVINCE: '',
    POSTAL_CODE: '96850',
  },
];
